"use strict";

var _objectWithoutProperties = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports.default = exports.TextInputType = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _TextInput = require("./TextInput.style");

var _helpers = require("../../utils/helpers");

var TextInputType = {
  Text: 'text',
  Email: 'email',
  Password: 'password',
  Search: 'search',
  TextArea: 'textarea'
};
exports.TextInputType = TextInputType;

var TextInput = function TextInput(_ref) {
  var name = _ref.name,
      label = _ref.label,
      placeholder = _ref.placeholder,
      value = _ref.value,
      inputType = _ref.inputType,
      onChangeCallback = _ref.onChangeCallback,
      rows = _ref.rows,
      rest = _objectWithoutProperties(_ref, ["name", "label", "placeholder", "value", "inputType", "onChangeCallback", "rows"]);

  var idRef = (0, _react.useRef)((0, _helpers.getUniqueID)());

  if (inputType === 'textarea') {
    return /*#__PURE__*/_react.default.createElement(_TextInput.TextInputWrapper, null, label && /*#__PURE__*/_react.default.createElement(_TextInput.Label, {
      htmlFor: idRef.current
    }, label), /*#__PURE__*/_react.default.createElement(_TextInput.TextArea, Object.assign({
      id: idRef.current,
      placeholder: placeholder,
      name: name,
      value: value,
      type: inputType,
      onChange: function onChange(_ref2) {
        var v = _ref2.target.value;
        return onChangeCallback(v);
      },
      rows: rows
    }, rest)));
  }

  return /*#__PURE__*/_react.default.createElement(_TextInput.TextInputWrapper, null, label && /*#__PURE__*/_react.default.createElement(_TextInput.Label, {
    htmlFor: idRef.current
  }, label), /*#__PURE__*/_react.default.createElement(_TextInput.Input, Object.assign({
    id: idRef.current,
    placeholder: placeholder,
    name: name,
    value: value,
    type: inputType,
    onChange: function onChange(_ref3) {
      var v = _ref3.target.value;
      return onChangeCallback(v);
    }
  }, rest)));
};

TextInput.propTypes = {
  name: _propTypes.default.string,
  label: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  value: _propTypes.default.string,
  inputType: _propTypes.default.oneOf(Object.values(TextInputType)),
  onChangeCallback: _propTypes.default.func,
  rows: _propTypes.default.number
};
TextInput.defaultProps = {
  name: '',
  label: null,
  placeholder: '',
  value: '',
  inputType: TextInputType.Text,
  onChangeCallback: function onChangeCallback() {},
  rows: 5
};
var _default = TextInput;
exports.default = _default;